// extracted by mini-css-extract-plugin
module.exports = {"section":"Page-module__section--3997J"};